export interface paddingStyleProps {
  type: 'none' | 'medium' | 'large' | 'xlarge' | 'custom'
  customPadding?: number
  customPaddingUnit?: 'em' | 'rem' | 'px'
}

export const getPadding = (paddingTop: any, paddingBottom: any) => {
  let paddingUnit = paddingTop[0].customPaddingUnit ? paddingTop[0].customPaddingUnit : 'em'

  let paddingStyle = {
    paddingTop: paddingTop[0].customPadding ? paddingTop[0].customPadding + paddingUnit : undefined,
    paddingBottom: paddingBottom[0].customPadding
      ? paddingBottom[0].customPadding + paddingUnit
      : undefined,
  }

  return {
    paddingUnit: paddingUnit,
    paddingStyle: paddingStyle,
  }
}
